import React from 'react'
import { withTranslation } from 'react-i18next'

import techSupport from '../svg/techSupport.svg'
import chat from '../svg/chat.svg'
import mail from '../svg/mail.svg'
import facebookMessengerLogo from '../images/png/facebookMessengerLogo.png'
import { Helmet } from 'react-helmet'

const Contacts = ({ t }) => {
    return (
        <div className="contacts-page">
            <Helmet>
                <title>{t('Contacts')} | Interacty</title>
            </Helmet>

            <h1>{t('Always in touch')}</h1>
            <img className="contacts-page__image__big-mt" src={techSupport} alt="" />
            <h2>{t('For technical support')}</h2>
            <div className="contacts-page__chat">
                <a href="mailto:info@interacty.me">
                    <img src={facebookMessengerLogo} alt="" />
                    <span>{t('let’s chat!')}</span>
                </a>
            </div>
            <img src={chat} alt="" />
            <h2>{t('For general questions and suggestions')}</h2>
            <a href="mailto:info@interacty.me" className="contacts-page__email">
                info@interacty.me
            </a>
            <img className="contacts-page__image__big-mt" src={mail} alt="" />
            <h2 className="contacts-page__for_old_letters">{t('For old-fashioned letters')}</h2>
            <div className="contacts-page__address">
                {t('LV-1082 Riga, Latvia')}
                <br />
                {t('Gunara Astras 8-1,54')}
            </div>
            <div className="contacts-page__legal-block">
                <div className="contacts-page__legal-block-name">{t('HOLGE SIA')}</div>
                <div className="contacts-page__legal-block-details">
                    {t('Registration number: 40203184732')}
                    <br />
                    {t('Legal address: LV-1082 Riga, Latvia, Gunara Astras 8-1,54')}
                    <br />
                    <span>+371 27 8 27 339 | </span>
                    <a href="mailto:info@interacty.me" className="contacts-page__legal-block-details-email">
                        info@interacty.me
                    </a>
                </div>
            </div>
        </div>
    )
}

export default withTranslation('translations')(Contacts)
